import { render, staticRenderFns } from "./tripBoard.vue?vue&type=template&id=bd56268e&scoped=true"
import script from "./tripBoard.vue?vue&type=script&lang=js"
export * from "./tripBoard.vue?vue&type=script&lang=js"
import style0 from "./tripBoard.vue?vue&type=style&index=0&id=bd56268e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd56268e",
  null
  
)

export default component.exports